/** @format */

import PinIcon from '@/assets/joivy_poi_miniature_pink.svg';
import { TTranslation, useAppTranslation } from '@/i18n/declarations';
import React from 'react';
import { scroller } from 'react-scroll';
import { WrapperInfoPosition } from '../index.style';

interface RoomInfoPositionProps {
  room: {
    city: {
      nameEn: string;
    };
    address: string;
  };
}

const RoomInfoPosition: React.FC<RoomInfoPositionProps> = ({ room }) => {
  const { t } = useAppTranslation();

  const scrollSecondaryHandler = (elementId: string) => {
    scroller.scrollTo(elementId, {
      duration: 875,
      smooth: true,
      offset: -100,
    });
  };

  return (
    <WrapperInfoPosition>
      <img src={PinIcon} alt="location" width={17} />
      <p>
        {t(room.city.nameEn.toLowerCase().replaceAll(' ', '_') as TTranslation)} <span>|</span>
      </p>
      <button onClick={() => scrollSecondaryHandler('mapAnchor')}>{room.address.toLowerCase()}</button>
    </WrapperInfoPosition>
  );
};

export default RoomInfoPosition;
